export const imageList = [
  { id: 1, imageName: "TwoFactorAuth.webp" },
  { id: 2, imageName: "ReleaseNotes.webp" },
  { id: 3, imageName: "DevicesNotSupported.webp" },
  { id: 4, imageName: "SFTPAnnouncement.webp" },
  { id: 5, imageName: "CCA_NewVersion.webp" },
  { id: 6, imageName: "DownloadCompliance.webp" },
  { id: 7, imageName: "BulkQuickSchedule.webp" },
  { id: 8, imageName: "ScopedAPIKeys.webp" },
  { id: 9, imageName: "VehicleLifecycle.webp" },
  { id: 10, imageName: "CreditsEmailSUpdate.webp" }
];
